import classNames from "classnames";
import React, { useRef, useState } from "react";

import { useMainStore } from "@/contexts/Store";

import downloadIcon from "../../../images/table-image/icon/download.svg";
import { stringToDate } from "../../helpers/DateFormatters";
import AttachmentDocumentDateSelect from "../shared/cell-type/AttachmentDocumentDateSelect";
import FileSelect from "../shared/cell-type/file-select/FileSelect";
import UsersCircleAuditTrails from "../shared/UsersCircleAuditTrails";
import InputTable from "./columns/InputTable";
import DeleteConfirmationDialog from "./DeleteConfirmationDialog";

type Props = {
  attachedDocumentID: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headers: any[];
  model: string;
  disabled?: boolean;
  documentNameValue?: string;
  documentType?: string;
  documentTypeValue?: string;
  isLocked?: boolean;
  multiline?: boolean;
  name?: string;
  recordID?: number;
  recordVersionID?: number;
  value?: string;
};

function AttachedDocumentRow({
  headers,
  data,
  model,
  attachedDocumentID,
  recordID,
  recordVersionID,
  isLocked,
  multiline,
}: Props) {
  // Import MobX stores
  const mainStore = useMainStore();

  // State
  const [params, setParams] = useState({});

  // Refs
  const textInput = useRef(null);

  // Variables
  const documentFileName = headers.find(
    (header) => header.field_name === "file_name",
  );

  // Functions
  // @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  const onKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      if (textInput.current) {
        // @ts-expect-error TS(2339) FIXME: Property 'blur' does not exist on type 'never'.
        textInput.current.blur();
      } else {
        persistData(event);
      }
    }
  };

  // @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  const onBlur = (event) => {
    persistData(event);
  };

  // @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  const persistData = (event) => {
    if (
      Object.keys(params).length > 0 &&
      (data.description !== event.target.value ||
        data.description !== event.target.innerText ||
        data.extras.file_name !== event.target.value ||
        data.extras.document_type !== event.target.value)
    ) {
      mainStore.attachedDocuments.update(attachedDocumentID, recordID, params);
    }
  };

  async function onDeleteYes() {
    await mainStore.attachedDocuments.delete(attachedDocumentID, recordID);
    mainStore.toast.setText(`Document ${title} deleted!`);
  }

  function onDeleteNo() {
    window.console.log("==> onDeleteNo (unused)");
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  function valueChanged(event) {
    event.preventDefault();

    // Get field name and the value
    const { name, value, innerText, dataset } = event.target;
    const multilineName = dataset.name;

    updateParamsValue(name, multilineName, value, innerText);
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'name' implicitly has an 'any' type.
  function updateParamsValue(name, multilineName, value, innerText) {
    if (documentFileName) {
      setParams({ extras: { [name || multilineName]: value || innerText } });
    } else {
      setParams({ [name || multilineName]: value || innerText });
    }
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
  function downloadingFile(id) {
    mainStore.attachedDocuments.fetchFileUrl(id);
  }

  const title = data.filename || "";

  const discardDeleteButtons = (
    <DeleteConfirmationDialog
      model="Document"
      onYes={onDeleteYes}
      onNo={onDeleteNo}
      title={title}
    />
  );

  // @ts-expect-error TS(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
  function renderFieldComponent(props, item) {
    const { name } = props;

    switch (name) {
      case "owner":
        return (
          <>
            <UsersCircleAuditTrails
              value={item.owner.initials}
              color={item.owner.icon_color_index}
            />
            <InputTable value={item.owner.full_name} name={name} disabled />
          </>
        );
      case "description":
        return (
          <InputTable
            value={item.extras?.description}
            name={name}
            onKeyDown={onKeyDown}
            onBlur={onBlur}
            multiline={multiline}
            textInput={textInput}
            disabled
            {...props}
          />
        );
      case "due_date":
        return (
          <AttachmentDocumentDateSelect
            initialValue={stringToDate(item.extras?.due_date)}
            attachedDocumentID={attachedDocumentID}
            fieldName="due_date"
            recordID={recordID}
            {...props}
          />
        );
      case "upload_date":
        return (
          <AttachmentDocumentDateSelect
            initialValue={stringToDate(item.upload_date)}
            attachedDocumentID={attachedDocumentID}
            recordID={recordID}
            {...props}
          />
        );
      case "file_upload_download":
        return (
          <FileSelect
            attachedDocumentID={attachedDocumentID}
            recordID={recordID}
            // @ts-expect-error TS(2322) FIXME: Type 'number | undefined' is not assignable to typ... Remove this comment to see the full error message
            recordVersionID={recordVersionID}
            otherFiles={data?.filename ? [data.filename] : []}
            isLockedTable={false}
            isLockedRow={false}
            downloadingFile={() => downloadingFile(item.id)}
            disabled={isLocked}
          />
        );
      case "filename":
        return (
          <>
            <InputTable value={item.filename} name={name} disabled />
            <img
              src={downloadIcon}
              alt="upload"
              onClick={() => downloadingFile(item.id)}
            />
          </>
        );
      case "document_type":
        return (
          <InputTable
            {...props}
            value={props.documentTypeValue}
            name="document_type"
            onKeyDown={onKeyDown}
            onBlur={onBlur}
            disabled={Boolean(data?.extras?.document_name) || isLocked}
          />
        );
      case "file_name":
        return (
          <InputTable
            {...props}
            value={props.documentNameValue}
            name={name}
            onKeyDown={onKeyDown}
            onBlur={onBlur}
            disabled={isLocked}
          />
        );
      default:
        return <InputTable {...props} model={model} disabled={isLocked} />;
    }
  }

  // elements
  const renderFields = headers.map((header) => {
    // @ts-expect-error TS(7006) FIXME: Parameter 'field_name' implicitly has an 'any' typ... Remove this comment to see the full error message
    const getValue = (field_name) => {
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (params[field_name]) {
        // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        return params[field_name];
      }
      if (Object.keys(data?.extras).includes(field_name)) {
        return data.extras[field_name];
      }
      return data[field_name];
    };
    const { field_name, disabled } = header;
    const width = header.width || 200;
    const style = { width };

    const value = getValue(field_name);
    const documentNameValue =
      // @ts-expect-error TS(2339) FIXME: Property 'extras' does not exist on type '{}'.
      params.extras === undefined
        ? data.extras.file_name
        : // @ts-expect-error TS(2339) FIXME: Property 'extras' does not exist on type '{}'.
          params.extras.file_name;
    const documentTypeValue =
      // @ts-expect-error TS(2339) FIXME: Property 'extras' does not exist on type '{}'.
      params.extras === undefined
        ? data.extras.document_name || data.extras.document_type
        : // @ts-expect-error TS(2339) FIXME: Property 'extras' does not exist on type '{}'.
          params.extras.document_type;
    const inputDisabled = disabled || isLocked;
    const props = {
      name: field_name,
      onChange: valueChanged,
      disabled: inputDisabled,
      isUserEditable: true,
      documentNameValue,
      documentTypeValue,
      value,
    };
    const liClassNames = classNames({
      disabled: inputDisabled,
      "form-enabled": !isLocked,
      "documents-file-input": props.name == "filename",
      "documents-document-name": Boolean(
        props.name == "document_type" && data?.extras?.document_name,
      ),
      "documents-upload-date": props.name === "upload_date",
      "documents-due_date": props.name === "due_date",
      "due-date-ad-error": Boolean(
        props.name == "due_date" &&
          data?.extras?.due_date &&
          new Date(data.extras.due_date) < new Date() &&
          !data.filename,
      ),
    });

    return (
      <li key={field_name} style={style} className={liClassNames}>
        {renderFieldComponent(props, data)}
      </li>
    );
  });

  return (
    <div
      className="list-table-settings"
      data-testid="list-settings-row"
      id={`${model?.toLowerCase()}-${data.id}`}
    >
      <ul>
        <div className="list-table-settings-wrap">
          {renderFields}
          <span className="stretch-cell" />
        </div>
        {!isLocked && (
          <div
            className="buttons-table-settings-wrap"
            data-testid="delete-document-button"
          >
            {discardDeleteButtons}
          </div>
        )}
      </ul>
    </div>
  );
}

AttachedDocumentRow.defaultProps = {
  isLocked: false,
  multiline: false,
};

export default AttachedDocumentRow;
